import { render } from "./terms-and-conditions-header.vue?vue&type=template&id=75c57081"
import script from "./terms-and-conditions-header.vue?vue&type=script&lang=js"
export * from "./terms-and-conditions-header.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__